import React from 'react'

class CallToAction extends React.Component{
  render(){
    return(
      <div className="cta-btn">
        <a id={this.props.clickid} href={this.props.link} className="btn">{this.props.content}</a>
      </div>
    )
  }
}

class RadialDownload extends React.Component{
  render(){
    return(
      <a id={this.props.clickid} href={this.props.link} className="radial-download-btn">
        <span className="sketch-download-arrow"><span className="path1"></span><span className="path2"></span></span>
      </a>
    )
  }
}

class DownloadAll extends React.Component{
  render(){
    return(
      <div className="download-all-btn">
        <a id={this.props.clickid} href={this.props.link}>{this.props.content}</a>
      </div>
    )
  }
}

class Download extends React.Component{
  render(){
    return(
      <div className="download-btn">
        <a href="" className="btn">DOWNLOAD</a>
      </div>
    )
  }
}

class DownloadSmall extends React.Component{
  render(){
    return(
      <div className="download-btn small">
        <a href={this.props.link} className="btn">DOWNLOAD</a>
      </div>
    )
  }
}

class DownloadLarge extends React.Component{
  render(){
    return(
      <div className="download-btn large">
        <a href={this.props.link} className="btn">DOWNLOAD</a>
      </div>
    )
  }
}

export { CallToAction, RadialDownload, DownloadAll, Download, DownloadSmall, DownloadLarge }



// WEBPACK FOOTER //
// ./src/components/Buttons/Buttons.js